import { Box, Flex, Heading, Stack, Stat, Text } from "@chakra-ui/react"
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts"

import type { TimeDistributionResponse } from "@/api/analytics"

interface TimeDistributionBarProps {
  title?: string
  data: TimeDistributionResponse
}

export function TimeDistributionBar({
  title = "Completion Time Distribution",
  data,
}: TimeDistributionBarProps) {
  const hasBuckets = data.buckets.length > 0

  return (
    <Box borderWidth="1px" borderRadius="lg" p={6} bg="bg.surface">
      <Heading size="lg" mb={4}>
        {title}
      </Heading>

      <Stack
        direction={{ base: "column", md: "row" }}
        gap={6}
        mb={6}
        align="stretch"
      >
        <Stat.Root>
          <Stat.Label>Average Time</Stat.Label>
          <Stat.ValueText>
            {secondsToDisplay(data.avg_completion_seconds)}
          </Stat.ValueText>
        </Stat.Root>
        <Stat.Root>
          <Stat.Label>Median Time</Stat.Label>
          <Stat.ValueText>
            {secondsToDisplay(data.median_completion_seconds)}
          </Stat.ValueText>
        </Stat.Root>
      </Stack>

      {!hasBuckets ? (
        <Flex align="center" justify="center" minH="180px">
          <Text color="fg.muted">No completion time data yet.</Text>
        </Flex>
      ) : (
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data.buckets}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="range_label" />
            <YAxis allowDecimals={false} />
            <Tooltip
              formatter={(value: number) => [`${value} attempts`, "Attempts"]}
            />
            <Bar dataKey="count" fill="#48bb78" name="Attempts" />
          </BarChart>
        </ResponsiveContainer>
      )}
    </Box>
  )
}

const secondsToDisplay = (seconds: number) => {
  const mins = Math.floor(seconds / 60)
  const secs = Math.round(seconds % 60)
  return `${mins}m ${secs}s`
}
